module.exports = __webpack_public_path__ + "img/guide_4_2.92a05fd8.svg";